// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import LikeOutline from '../_raw/ui/icon_like_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(LikeOutline);
